import { FormBuilder, Validators } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';
import { GoalType } from '../enums/GoalType.enum';
import { DigitalVideoMeasurementViewability } from '../components/planner-edit/constants/DigitalVideoViewabilityMeasurement.const';

export class GoalDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        {
            name: 'goalTypeId',
            type: GoalType,
            defaultValue: GoalType.DELIVERY_VIEWABILITY
        },
        {
            name: 'rank',
            type: 'number',
            defaultValue: 0
        },
        {
            name: 'deliveryGoalThreshold',
            type: 'number',
            defaultValue: 50,
            validators: [Validators.required, Validators.min(1), Validators.max(100)]
        },
        {
            name: 'goalCurrencyValue',
            type: 'number'
        },
        {
            name: 'viewabilityMeasurementId',
            type: 'number',
            defaultValue: DigitalVideoMeasurementViewability.MRC.id
        },
        {
            name: 'hardGoal',
            type: 'boolean',
            defaultValue: true
        }
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}
